// extracted by mini-css-extract-plugin
export default {"input_box_container":"SsnInput_input_box_container__muWDo","inputField":"SsnInput_inputField__iat4c","label":"SsnInput_label__0ak7P"};